/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as l from "react";
import { useUnstyled as u, classNames as c, uCalendar as s } from "@progress/kendo-react-common";
const g = (e) => {
  const { className: i, isRangeStart: m, value: r, text: N, view: k, ...o } = e, a = u(), t = a && a.uCalendar, d = (C) => {
    var n;
    (n = e.onClick) == null || n.call(e, r, C);
  };
  return /* @__PURE__ */ l.createElement(
    "li",
    {
      ...o,
      onClick: d,
      className: c(s.li({ c: t }), i)
    },
    /* @__PURE__ */ l.createElement(
      "span",
      {
        className: c(
          s.navigationMarker({
            c: t,
            isRangeStart: m
          })
        )
      },
      e.children
    )
  );
};
export {
  g as CalendarNavigationItem
};
